module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAR5JREFUSEvVlQEOgjAMRdub4EnUkygnUU8inkQ8idyk7pONlAY2SkKIJCSSdH39f9uXaeOHN+5P+wNE5LpQZcvMna3NKhCRJxEtBaD3wUImASJyipMAUBFRXVBxISKsOTNzq2tHABFBs3dsOtQx81KlRcAtdL2HaTAFXthTJUC0DEOkp4YlysoiANNDau+liPTfAER1X2NVw8y1G6Am1gCA8d2EAV7ptxcA+ZgYTcgoSIB0FFHrU2BPigZEICzSe9B77rEIUx6DRQ+rIHdMPYDZTf4vgD1FC7MIZcV7MHmK4qXLcbAObx5QOkVzBM8m2+REdHjCDjHzCRHTpVQdQmwmChz2j0oHq2ya4h7oi7QKkJIAi/f/y1wlQS3aXMEPNHjHGQJIXJ0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/img/water.png
// module id = veEz
// module chunks = 1